// Managers' team tools (ADR 0007): Live now and coaching notes. Coaching mode is retired
// (2026-10-25): listening needs nothing turned on.
import { queryOptions } from "@tanstack/react-query";
import { api } from "./client";
import type { CoachingNote, CoachingNoteList, LiveCallList } from "./types";

const enc = encodeURIComponent;

export const team = {
  live: () => api<LiveCallList>("/v1/team/live"),
  notes: (callId: string) => api<CoachingNoteList>(`/v1/calls/${enc(callId)}/notes`),
  addNote: (callId: string, body: string) =>
    api<CoachingNote>(`/v1/calls/${enc(callId)}/notes`, { method: "POST", body: { body } }),
  deleteNote: (callId: string, noteId: string) =>
    api<void>(`/v1/calls/${enc(callId)}/notes/${enc(noteId)}`, { method: "DELETE" }),
};

export const teamKeys = {
  live: ["team", "live"] as const,
  notes: (callId: string) => ["team", "notes", callId] as const,
};

export const liveQuery = queryOptions({ queryKey: teamKeys.live, queryFn: team.live });
export const notesQuery = (callId: string) =>
  queryOptions({ queryKey: teamKeys.notes(callId), queryFn: () => team.notes(callId) });
